/**
 * 首页
 */
import { Card, Row, Col, Statistic } from 'antd';
import {
  LineChartOutlined,
  ThunderboltOutlined,
  GlobalOutlined,
  RiseOutlined,
} from '@ant-design/icons';
import './Home.scss';

export default function Home() {
  return (
    <div className="home-page">
      <h2>关于产业地图</h2>
      <p style={{ marginBottom: 24, color: '#666' }}>
        实时追踪全球钒产业动态，洞察市场趋势
      </p>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="V2O5价格"
              value={0}
              precision={2}
              valueStyle={{ color: '#3f8600' }}
              prefix={<LineChartOutlined />}
              suffix="元/吨"
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="全球储能项目"
              value={25}
              valueStyle={{ fontSize: '24px', fontWeight: 'bold' }}
              prefix={<ThunderboltOutlined />}
              suffix={<span style={{ fontSize: '14px', marginLeft: '4px' }}>个</span>}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card className="stat-card">
            <Statistic
              title="总装机容量"
              value={1806}
              precision={0}
              valueStyle={{ fontSize: '24px', fontWeight: 'bold' }}
              prefix={<GlobalOutlined />}
              suffix={<span style={{ fontSize: '14px', marginLeft: '4px' }}>MWh</span>}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card className="stat-card">
            <Statistic
              title="年度产量"
              value={115000}
              precision={0}
              valueStyle={{ fontSize: '24px', fontWeight: 'bold' }}
              prefix={<RiseOutlined />}
              suffix={<span style={{ fontSize: '14px', marginLeft: '4px' }}>吨</span>}
            />
          </Card>
        </Col>
      </Row>

      <Card style={{ marginTop: 24 }} title="平台功能">
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <h3>📈 价格趋势分析</h3>
            <p>实时追踪V2O5、钒铁等产品价格，支持多币种、多时间粒度查看</p>
          </Col>
          <Col xs={24} md={12}>
            <h3>🗺️ 产业链地图</h3>
            <p>可视化展示钒产业上下游关系，了解各环节市场规模</p>
          </Col>
          <Col xs={24} md={12}>
            <h3>⚡ 储能项目分布</h3>
            <p>全球钒液流电池项目地图，查看项目详情和统计数据</p>
          </Col>
          <Col xs={24} md={12}>
            <h3>📊 供需分析</h3>
            <p>分析全球钒产量、需求和供需平衡，预测市场趋势</p>
          </Col>
        </Row>
      </Card>
    </div>
  );
}
